import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'func',
})
export class FunctionPipe implements PipeTransform {
  transform(handleFn: (...params: any[]) => any, ...args: any[]): any {
    return handleFn(...args);
  }
}
